import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/fe-webapp-next/components/app-param-initializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientErrorDetector"] */ "/app/fe-webapp-next/components/client-error-detector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HtmlLangSync"] */ "/app/fe-webapp-next/components/html-lang-sync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHog"] */ "/app/fe-webapp-next/components/post-hog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/fe-webapp-next/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebpackErrorHandler"] */ "/app/fe-webapp-next/components/webpack-error-handler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppProvider"] */ "/app/fe-webapp-next/contexts/app-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RecentlyViewedProvider"] */ "/app/fe-webapp-next/contexts/recently-viewed-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryProvider"] */ "/app/fe-webapp-next/providers/query-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.9.1_next@15.5.15_@babel+core@7.29.0_@opentelemetry+api@1.9.1_babel-plugin-r_d4351051f36dadcdea1f20e9d7ce036c/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/nextjs-toploader@3.9.17_next@15.5.15_@babel+core@7.29.0_@opentelemetry+api@1.9.1_babel-_3737c3de9d034365fe124aa962384da7/node_modules/nextjs-toploader/dist/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/.pnpm/sonner@2.0.7_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/sonner/dist/index.mjs");
